export default __webpack_public_path__ + "fonts/dotted-yellow-choose-prize-PC.svg";